import { NgxLoadingButtonsModule } from 'ngx-loading-buttons';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';

import { SnCommonModule } from '@lib/common';
import { SnFormModule } from '@lib/form';
import { SnFormCheckboxModule } from '@lib/form/checkbox';
import { SnShareModule } from '@lib/share';
import { SnTeamsModule } from '@lib/teams';
import { TranslationModule } from '@lib/translation/translation.module';
import { SnActionsModule } from '@lib/ui/actions';
import { SnAvatarModule } from '@lib/ui/avatar';
import { SnButtonModule } from '@lib/ui/button';
import { SnDataListModule } from '@lib/ui/data-list';
import { SnIconModule } from '@lib/ui/icon';
import { SnListModule } from '@lib/ui/list';

import { BulkActivateAccessRequestDialogComponent } from './components/bulk-activate-access-request-dialog';
import { UserDetailsComponent } from './components/user-details';
import { UserRequestsTableComponent } from './components/user-requests-table';
import { UserSearchDialogComponent } from './components/user-search-dialog/user-search-dialog.component';
import { UserSelectComponent } from './components/user-select';
import { UserSelectDialogComponent } from './components/user-select-dialog/user-select-dialog.component';
import { UserTableComponent } from './components/user-table';

@NgModule({
  imports: [
    // Angular
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    // Material
    MatSortModule,
    MatTableModule,
    MatSelectModule,
    MatProgressBarModule,
    MatDialogModule,
    MatListModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    // Libs
    SnCommonModule,
    SnListModule,
    SnDataListModule,
    SnIconModule,
    SnShareModule,
    SnAvatarModule,
    SnActionsModule,
    SnFormCheckboxModule,
    SnTeamsModule,
    SnButtonModule,
    MatButtonModule,
    MatTooltipModule,
    SnFormModule,
    NgxLoadingButtonsModule,
    TranslationModule,
  ],
  exports: [
    UserTableComponent,
    UserSelectComponent,
    UserDetailsComponent,
    UserRequestsTableComponent,
    BulkActivateAccessRequestDialogComponent,
  ],
  declarations: [
    UserTableComponent,
    UserSelectComponent,
    UserDetailsComponent,
    UserRequestsTableComponent,
    UserSelectDialogComponent,
    BulkActivateAccessRequestDialogComponent,
    UserSearchDialogComponent,
  ],
})
export class SnUsersModule {}
